import effectManager from '../effect';
import Param from '../../param';

const param = new Param();
export default class keyVisual{
    constructor(effect){

        this.h = window.innerHeight;

        this.effect = effect;

        /* 必要なDOM */
        this.$container;
        this.$link;

        this.$selectStageLink;

        this.$stageSky

        this.flg = false; /* スクロール移動の際にhover表示しているものをoutしたか */


        /* ステータス */
        this.status = {
            device : "pc",
            init : false,
            execution:false
        }


    }
    init(pageID) {

        if(this.status.init) return;
        this.status.init = true;

        this.$container =  document.getElementById("l-kv");
        this.$link =  this.$container.querySelectorAll(".stage.js__type-link >a");


        /* リンクにclickイベント追加 */
        for(let i in this.$link){
            if(this.$link[i].nodeType!=1) break; // dom要素以外は処理止める
            this.$link[i].addEventListener("click",()=> {
                this.status.execution = true;
            })
        }


        // hover動作追加
        if(Useragnt.pc){

            let _select=[];
            for(let i in this.$container.querySelectorAll(".stage.js__type-link")){
                if(this.$container.querySelectorAll(".stage.js__type-link")[i].nodeType!=1) break; // dom要素以外は処理止める
                _select[i] = this.$container.querySelectorAll(".stage.js__type-link")[i].getAttribute("data-current");
                // effect[_select[i]] = new effectManager();
                // effect[_select[i]].splitText(document.getElementById("stage-link-"+_select[i]).querySelectorAll(".js__splittext"),"set")
                // effect[_select[i]].show(document.getElementById("stage-link-"+_select[i]).querySelectorAll(".stage-link-hover-sub"),"set")

                // effect = new effectManager();
                this.effect.splitText(document.getElementById("stage-link-"+_select[i]).querySelectorAll(".js__splittext"),"set")
                this.effect.show(document.getElementById("stage-link-"+_select[i]).querySelectorAll(".stage-link-hover-sub"),"set")

            }

            for(let i in this.$link){
                if(this.$link[i].nodeType!=1) break; // dom要素以外は処理止める

                this.$link[i].addEventListener("mouseenter",(e)=> {


                    let _$parent = e.target.parentElement;
                    let _current = _$parent.getAttribute("data-current")

                    this.$selectStageLink = document.getElementById("stage-link-"+_current);

                    if(!this.$selectStageLink) return;

                    TweenMax.killChildTweensOf(this.$selectStageLink.querySelectorAll(".js__splittext"));

                    this.effect.splitText(this.$selectStageLink.querySelectorAll(".js__splittext >* >*"),"show");
                    this.effect.show(this.$selectStageLink.querySelectorAll(".stage-link-hover-sub"),"show");
                    _$parent.classList.add("is-on");


                    for(let j in this.$link){
                        if(this.$link[j].nodeType!=1) break; // dom要素以外は処理止める
                        if(!this.$link[j].parentElement.classList.contains("is-on")){
                            this.$link[j].parentElement.classList.add("is-out");
                        }
                    }

                    document.getElementById("p-sky-stage").classList.add("is-out");

                })
                this.$link[i].addEventListener("mouseleave", (e)=> {

                    if(!this.$selectStageLink) return;
                    
                    let _$parent = e.target.parentElement;
                    // let _current = _$parent.getAttribute("data-current")

                    _$parent.classList.remove("is-on");
                    // TweenMax.killChildTweensOf(this.$selectStageLink.querySelectorAll(".js__splittext"));
                    this.effect.splitText(this.$selectStageLink.querySelectorAll(".js__splittext >* >*"),"out");
                    this.effect.show(this.$selectStageLink.querySelectorAll(".stage-link-hover-sub"),"out");
                    for(let j in this.$link){
                        if(this.$link[j].nodeType!=1) break; // dom要素以外は処理止める
                        this.$link[j].parentElement.classList.remove("is-out");
                    }
                    document.getElementById("p-sky-stage").classList.remove("is-out");

                });

            }

        }



    }
    render(scrollInc){

        if(scrollInc>10){
            if(!this.flg&&this.$selectStageLink){
                this.flg = true;
                if(this.$selectStageLink.querySelectorAll(" .js__splittext >* >*")[0]) this.effect.splitText(this.$selectStageLink.querySelectorAll(" .js__splittext >* >*"),"outSimple");
                if(this.$selectStageLink.querySelectorAll(" .stage-link-hover-sub")[0]) this.effect.show(this.$selectStageLink.querySelectorAll(" .stage-link-hover-sub"),"outSimple");
            }
        }else{
            this.flg = false;
        }

    }
    resize(){
        let _w = window.innerWidth;
        this.h = window.innerHeight;
        if(_w>param.breakpoint){
            // if(this.status.device==="sp") this.set("pc");
            this.status.device = "pc";
        }else{
            // if(this.status.device==="pc") this.set("sp");
            this.status.device = "sp";
        }

    }
}